function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Omannet = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, React) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = void 0;
  React = _interopRequireWildcard(React);

  function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

  function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

  var SvgOmannet = function SvgOmannet(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: props.className,
      style: props.style
    }, /*#__PURE__*/React.createElement("svg", _extends({
      viewBox: "0 0 60 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/React.createElement("rect", {
      width: 60,
      height: 40,
      fill: "#F3F6F9"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20.7999 23.4842H18.8867C19.2756 23.1731 19.3378 22.8776 19.3378 22.3643V20.4044C19.3378 19.8911 19.2756 19.58 18.9022 19.2689H19.8977C20.0377 19.2689 20.1155 19.2534 20.2244 19.1445V19.8133C20.6599 19.3623 21.2977 19.1134 21.9821 19.1134C22.682 19.1134 23.242 19.4245 23.5064 19.8911C23.973 19.3934 24.6574 19.1134 25.4507 19.1134C26.7262 19.1134 27.3639 19.72 27.3639 20.9177V22.3487C27.3639 22.3643 27.3639 22.3954 27.3639 22.411C27.3639 22.8465 27.3795 23.1265 27.7995 23.4842H25.9018C26.2907 23.1731 26.3529 22.8776 26.3529 22.3643V21.3066C26.3529 20.3733 26.0418 19.9222 25.233 19.9222C24.393 19.9222 23.8331 20.4511 23.8331 21.3533V22.3643C23.8331 22.8309 23.8486 23.142 24.2841 23.4842H22.3709C22.7753 23.1576 22.822 22.862 22.822 22.3643V21.3066C22.822 20.3733 22.5109 19.9222 21.7332 19.9222C20.9243 19.9222 20.3644 20.4355 20.3644 21.3533V22.3643C20.3488 22.8309 20.3488 23.1265 20.7999 23.4842Z",
      fill: "url(#paint0_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M30.1171 23.6242C28.7639 23.6242 28.0328 23.142 28.0328 22.3643C28.0328 21.1666 29.2927 20.84 31.8903 20.8244C31.8903 20.8088 31.8903 20.8088 31.8903 20.7933C31.8903 20.1244 31.5481 19.8756 30.7238 19.8756C30.1949 19.8756 29.3394 20.0311 28.3595 20.4355L28.7483 19.2689C28.8105 19.3001 28.8883 19.3156 28.9661 19.3156C29.4016 19.3156 30.0705 19.129 30.9104 19.129C32.3259 19.129 32.9014 19.6889 32.9014 20.98V22.3176C32.9014 22.7843 32.9636 23.1109 33.4614 23.4998H32.4503C32.2792 23.4998 32.1392 23.3598 32.0926 23.1109C31.6415 23.4531 30.9726 23.6242 30.1171 23.6242ZM29.075 22.2399C29.075 22.6132 29.4794 22.8776 30.2416 22.8776C31.2837 22.8776 31.8903 22.411 31.8903 21.8043V21.5555C29.9927 21.5866 29.075 21.6955 29.075 22.2399Z",
      fill: "url(#paint1_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M35.7168 23.4842H33.8036C34.208 23.1576 34.2546 22.862 34.2546 22.3643V20.4044C34.2546 19.8911 34.1924 19.5956 33.8191 19.2689H34.8146C34.9546 19.2689 35.0635 19.2378 35.1413 19.1445V19.8133C35.6546 19.3312 36.2923 19.1134 37.1011 19.1134C38.3922 19.1134 39.0144 19.7045 39.0144 20.9177V22.3487C39.0144 22.8309 39.0299 23.1265 39.4499 23.4687H37.5522C37.9566 23.142 37.9877 22.8465 37.9877 22.3487V21.2288C37.9877 20.2955 37.7078 19.8289 36.8056 19.8289C35.8412 19.8289 35.2346 20.3422 35.2346 21.2599V22.3487C35.2657 22.8465 35.2968 23.142 35.7168 23.4842Z",
      fill: "url(#paint2_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M41.4875 22.4421C41.5031 22.9554 41.5809 23.2665 41.9542 23.4842H39.9787C40.3365 23.282 40.4454 22.9709 40.4454 22.4421V19.0201C40.4454 18.4912 40.3365 18.1645 39.9787 17.9779L41.472 17.9934L45.2206 21.7888L45.2051 18.9734C45.2051 18.429 45.0806 18.1023 44.7384 17.9312H46.6672C46.2472 18.1801 46.2317 18.4912 46.2317 18.9423C46.2317 18.9578 46.2317 18.9889 46.2317 19.0045V23.7331C46.2161 23.7175 46.0139 23.7175 45.7962 23.6087C45.3917 23.422 45.034 23.1576 44.7384 22.8465L41.4253 19.4556L41.4875 22.4421Z",
      fill: "url(#paint3_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M50.167 22.9243C49.0004 22.9243 48.036 21.9132 48.036 21.3377C48.036 21.3221 48.036 21.3221 48.036 21.3066H51.738C51.7691 21.3066 51.8003 21.3066 51.8158 21.3066C51.9402 21.3066 52.2202 21.3066 52.2202 21.3066C52.2202 19.9067 51.3025 19.0667 49.5137 19.0667C47.7561 19.0667 46.8228 20.3266 46.8228 21.291C46.8228 22.6754 48.0049 23.702 49.887 23.6242C52.0647 23.5309 52.2513 22.4887 52.2513 22.4887C51.5825 22.8776 50.9448 22.9243 50.167 22.9243ZM49.5759 19.7667C50.4626 19.7667 50.9603 20.1244 50.9603 20.6377C50.9603 20.6533 50.9603 20.6533 50.9603 20.6533H48.0827C48.1294 20.14 48.6582 19.7667 49.5759 19.7667Z",
      fill: "url(#paint4_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M54.3045 21.6021C54.3045 21.5555 54.3045 21.5088 54.3045 21.4621V20.0155H55.9844V19.2534H54.3201V18.429C54.3201 18.3979 54.3201 18.3823 54.3201 18.3512C54.3201 18.1801 54.3201 18.009 54.3201 18.009H53.7912C53.7912 19.2067 53.4646 19.5334 52.4069 19.5334L52.5624 20.0155H53.2935L53.2779 21.5243C53.2779 21.6177 53.2779 21.8665 53.2779 21.9599C53.2779 22.4265 53.309 22.8465 53.6512 23.2198C53.9468 23.5309 54.3356 23.6553 54.8956 23.6553C55.7044 23.6553 56 22.862 56 22.862C55.72 23.002 55.0978 23.0176 55.0978 23.0176C54.3978 22.9865 54.3045 22.2865 54.3045 21.6021Z",
      fill: "url(#paint5_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12.6027 16.9202L10.2228 10.745L10.8139 10.5272L13.1782 16.7024L12.6027 16.9202Z",
      fill: "url(#paint6_linear)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15.1847 16.6247L14.5781 16.5469L15.0758 13.156L15.698 13.2337L15.1847 16.6247Z",
      fill: "url(#paint7_linear)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17.129 17.8068L16.6469 17.4024L21.3288 11.6627L21.811 12.0516L17.129 17.8068Z",
      fill: "url(#paint8_linear)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.0472 18.0401L8.04517 15.2558L8.46514 14.8048L11.4672 17.5735L11.0472 18.0401Z",
      fill: "url(#paint9_linear)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5.8389 19.3583L5.77719 19.9774L10.2504 20.4233L10.3122 19.8042L5.8389 19.3583Z",
      fill: "#55B350"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7.40741 24.7597L7.09631 24.2153L10.7983 22.1154L11.1094 22.6598L7.40741 24.7597Z",
      fill: "url(#paint10_linear)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13.1626 27.5907L12.556 27.4818L13.3181 23.4842L13.9248 23.6087L13.1626 27.5907Z",
      fill: "url(#paint11_linear)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18.7 29.5039L15.6513 23.6398L16.1957 23.3442L19.26 29.2239L18.7 29.5039Z",
      fill: "url(#paint12_linear)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15.3247 21.4466H15.2936C15.0914 21.2755 14.8269 21.0577 14.5003 20.7311C14.4381 20.6688 14.3603 20.5911 14.3136 20.5289C14.3292 20.4822 14.3292 20.42 14.3292 20.3578V20.2644C14.3914 20.2022 14.4381 20.14 14.4847 20.0778H14.5003V20.0933C14.5003 20.1555 14.5781 20.2022 14.6869 20.2022C14.7647 20.2022 14.8425 20.1711 14.858 20.1244H14.9514V20.1867C14.9514 20.2178 14.9825 20.2489 15.0136 20.2489H15.6824C15.7136 20.2489 15.7447 20.2178 15.7447 20.1867V19.8756C15.7447 19.8444 15.7136 19.8133 15.6824 19.8133H15.0136C14.9825 19.8133 14.9514 19.8444 14.9514 19.8756V19.9378H14.858C14.8425 19.8911 14.7647 19.8444 14.6714 19.8444H14.6558C15.0914 19.0823 15.3869 18.4445 15.3091 18.3979C15.2314 18.3668 14.8114 18.9423 14.3603 19.7045L14.3914 19.72C14.3759 19.7511 14.3447 19.7822 14.3136 19.8289V19.7978V19.7045V19.6111V19.5178V19.4245V19.3623C14.2203 19.3623 14.1581 19.3156 14.1581 19.2534H14.1425V19.1445H14.127V19.0356V18.9578H14.1114V18.8178V18.7401C14.127 18.7401 14.1425 18.7245 14.1581 18.7245C14.1892 18.709 14.2048 18.709 14.2203 18.6934C14.2359 18.6779 14.2514 18.6623 14.267 18.6312H14.2825C14.3136 18.6312 14.3447 18.6001 14.3447 18.569C14.3447 18.5379 14.3136 18.5068 14.2825 18.5068C14.2825 18.5068 14.2825 18.5068 14.267 18.5068C14.2514 18.4756 14.2359 18.4601 14.2048 18.429C14.1892 18.4134 14.1581 18.4134 14.1425 18.3979C14.127 18.3823 14.0959 18.3823 14.0803 18.3823C14.0803 18.3512 14.0492 18.3201 14.0181 18.3201C13.987 18.3201 13.9559 18.3512 13.9559 18.3823C13.9403 18.3823 13.9092 18.3979 13.8937 18.3979C13.8626 18.4134 13.847 18.4134 13.8314 18.429C13.8003 18.4445 13.7848 18.4756 13.7692 18.5068C13.7692 18.5068 13.7692 18.5068 13.7537 18.5068C13.7226 18.5068 13.6915 18.5379 13.6915 18.569C13.6915 18.6001 13.7226 18.6312 13.7537 18.6312H13.7692C13.7848 18.6467 13.8003 18.6623 13.8159 18.6934C13.8314 18.709 13.847 18.7245 13.8781 18.7245C13.8781 18.7245 13.8937 18.7245 13.8937 18.7401V18.8178V18.9578H13.8781V19.0667V19.1756H13.8626V19.2845H13.847C13.847 19.3467 13.7848 19.3934 13.6915 19.3934V19.4556V19.4867V19.5489V19.6422V19.7356V19.7978C13.6915 19.8133 13.6915 19.8445 13.6915 19.86C13.6603 19.8133 13.6292 19.7822 13.6137 19.7511L13.6448 19.7356C13.2093 18.9734 12.7893 18.3823 12.696 18.429C12.6182 18.4601 12.8982 19.0978 13.3337 19.8444C13.2404 19.8444 13.1626 19.8911 13.147 19.9378H13.0537V19.8911C13.0537 19.86 13.0226 19.8289 12.9915 19.8289H12.3226C12.2915 19.8289 12.2604 19.86 12.2604 19.8911V20.2022C12.2604 20.2333 12.2915 20.2644 12.3226 20.2644H12.9915C13.0226 20.2644 13.0537 20.2333 13.0537 20.2022V20.1244H13.1626C13.1937 20.1711 13.2559 20.2022 13.3337 20.2022C13.4115 20.2022 13.4892 20.1711 13.5048 20.1244C13.5204 20.14 13.5515 20.1555 13.5826 20.1555C13.6137 20.2022 13.6448 20.2333 13.6759 20.28C13.6759 20.3422 13.6603 20.3733 13.6448 20.3889H13.5515V20.4044C13.3959 20.42 13.0848 20.42 12.8204 20.4355V20.42L12.696 20.4355C12.5093 20.4511 12.3693 20.4977 12.3693 20.56C12.3693 20.6222 12.5093 20.7 12.696 20.7466C12.696 20.7466 12.696 20.7466 12.696 20.7622L12.8204 20.7933C12.8204 20.7933 12.8204 20.7933 12.8204 20.7777C12.9915 20.8244 13.1937 20.8555 13.3648 20.8866C13.1004 21.1355 12.8826 21.3221 12.7115 21.4621L12.696 21.4466C12.4315 21.7421 12.1515 21.8665 12.2449 21.9132C12.3538 21.9754 12.7115 21.8354 13.0382 21.5243H13.0226C13.2248 21.3532 13.4737 21.151 13.707 20.9022C13.9092 20.9022 14.0492 20.8555 14.1581 20.7622C14.1736 20.7777 14.1892 20.7933 14.2048 20.8088C14.4847 21.0888 14.7492 21.3221 14.9825 21.5243H14.9669C15.2936 21.8354 15.6669 21.9599 15.7602 21.9132C15.8847 21.8665 15.6047 21.7266 15.3247 21.4466ZM14.6247 19.8444L14.6558 19.86C14.6403 19.86 14.6247 19.86 14.6247 19.86V19.8444Z",
      fill: "#B2141C"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13.987 16.7335C11.4672 16.7335 9.98947 18.1801 9.98947 20.3111C9.98947 22.4576 11.436 23.8109 13.8159 23.8109C16.3358 23.8109 17.8134 22.3487 17.8134 20.2333C17.8134 18.0712 16.3824 16.7335 13.987 16.7335ZM13.8003 23.0643C12.136 23.0643 11.125 22.0377 11.125 20.3422C11.125 18.5379 12.2138 17.449 14.0181 17.449C15.698 17.449 16.6624 18.4445 16.6624 20.2178C16.6624 21.9754 15.6047 23.0643 13.8003 23.0643Z",
      fill: "#3CA647"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14.0026 16.3291C11.2027 16.3291 9.55396 17.9312 9.55396 20.2955C9.55396 22.6754 11.1561 24.1842 13.8159 24.1842C16.6157 24.1842 18.2645 22.551 18.2645 20.2178C18.2645 17.8224 16.6624 16.3291 14.0026 16.3291ZM13.8315 23.5465C11.6072 23.5465 10.285 22.2865 10.285 20.2955C10.285 18.3201 11.6694 16.9824 14.0026 16.9824C16.2269 16.9824 17.549 18.2268 17.549 20.2333C17.5335 22.1932 16.1647 23.5465 13.8315 23.5465Z",
      fill: "#B2141C"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15.3869 14.0581C15.8594 14.0581 16.2424 13.6751 16.2424 13.2026C16.2424 12.7302 15.8594 12.3471 15.3869 12.3471C14.9144 12.3471 14.5314 12.7302 14.5314 13.2026C14.5314 13.6751 14.9144 14.0581 15.3869 14.0581Z",
      fill: "url(#paint13_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21.5621 12.7205C22.0346 12.7205 22.4176 12.3374 22.4176 11.8649C22.4176 11.3925 22.0346 11.0094 21.5621 11.0094C21.0896 11.0094 20.7066 11.3925 20.7066 11.8649C20.7066 12.3374 21.0896 12.7205 21.5621 12.7205Z",
      fill: "url(#paint14_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10.5183 11.4916C10.9908 11.4916 11.3738 11.1086 11.3738 10.6361C11.3738 10.1636 10.9908 9.78062 10.5183 9.78062C10.0459 9.78062 9.66284 10.1636 9.66284 10.6361C9.66284 11.1086 10.0459 11.4916 10.5183 11.4916Z",
      fill: "url(#paint15_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.24735 15.8936C8.71983 15.8936 9.10285 15.5106 9.10285 15.0381C9.10285 14.5656 8.71983 14.1826 8.24735 14.1826C7.77487 14.1826 7.39185 14.5656 7.39185 15.0381C7.39185 15.5106 7.77487 15.8936 8.24735 15.8936Z",
      fill: "url(#paint16_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5.80527 20.5289C6.27775 20.5289 6.66077 20.1458 6.66077 19.6734C6.66077 19.2009 6.27775 18.8179 5.80527 18.8179C5.33279 18.8179 4.94977 19.2009 4.94977 19.6734C4.94977 20.1458 5.33279 20.5289 5.80527 20.5289Z",
      fill: "url(#paint17_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7.25187 25.3352C7.72435 25.3352 8.10737 24.9522 8.10737 24.4797C8.10737 24.0072 7.72435 23.6242 7.25187 23.6242C6.77938 23.6242 6.39636 24.0072 6.39636 24.4797C6.39636 24.9522 6.77938 25.3352 7.25187 25.3352Z",
      fill: "url(#paint18_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12.8982 28.3217C13.3707 28.3217 13.7537 27.9387 13.7537 27.4662C13.7537 26.9937 13.3707 26.6107 12.8982 26.6107C12.4257 26.6107 12.0427 26.9937 12.0427 27.4662C12.0427 27.9387 12.4257 28.3217 12.8982 28.3217Z",
      fill: "url(#paint19_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18.9023 30.2194C19.3747 30.2194 19.7578 29.8363 19.7578 29.3639C19.7578 28.8914 19.3747 28.5084 18.9023 28.5084C18.4298 28.5084 18.0468 28.8914 18.0468 29.3639C18.0468 29.8363 18.4298 30.2194 18.9023 30.2194Z",
      fill: "url(#paint20_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M32.2637 13.3582C32.5281 13.3582 32.7303 13.1249 32.7303 12.8293C32.7303 12.5338 32.5126 12.3005 32.2637 12.3005C31.9993 12.3005 31.7971 12.5338 31.7971 12.8293C31.7971 13.1249 31.9993 13.3582 32.2637 13.3582Z",
      fill: "#B2141C"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M26.6329 13.2337C26.8973 13.2337 27.0995 13.0004 27.0995 12.7049C27.0995 12.4093 26.8818 12.176 26.6329 12.176C26.384 12.176 26.1663 12.4093 26.1663 12.7049C26.1663 13.0004 26.3685 13.2337 26.6329 13.2337Z",
      fill: "#B2141C"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M27.6595 13.2337C27.9239 13.2337 28.1261 13.0004 28.1261 12.7049C28.1261 12.4093 27.9084 12.176 27.6595 12.176C27.3951 12.176 27.1928 12.4093 27.1928 12.7049C27.1928 13.0004 27.4106 13.2337 27.6595 13.2337Z",
      fill: "#B2141C"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M33.6792 15.9869V13.5759C33.6792 13.5759 32.8081 13.7159 32.5437 13.7626C32.777 13.9337 32.777 14.2603 32.777 14.5559C32.777 14.8203 32.777 15.7847 32.777 16.0958H30.8327V13.5759C30.8327 13.5759 29.9616 13.7159 29.6972 13.7626C29.9305 13.9337 29.9305 14.2603 29.9305 14.5559C29.9305 14.8203 29.9305 15.7847 29.9305 16.0958H25.9952C25.4508 16.0958 25.0619 15.9714 25.0619 15.3492C25.0619 14.7892 25.8241 14.3381 26.3529 14.4003C26.9907 14.4781 27.2084 14.9759 27.2084 14.9759V14.1826C27.2084 14.1826 26.1352 13.7937 25.3419 14.1826C24.5486 14.5714 24.2997 15.1936 24.3153 15.6603C24.3308 16.1269 24.8752 16.5313 25.0775 16.5313H25.9641H33.1192H33.5392H33.8969C33.8814 16.5158 33.6792 16.4535 33.6792 15.9869Z",
      fill: "#B2141C"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M50.3848 15.8314C50.3848 15.8314 50.1981 16.0336 49.9959 16.0336H48.9848C48.7049 16.0336 48.3627 15.8625 48.3627 15.0536C48.3627 14.2448 48.7515 13.9337 49.1248 13.9337C49.7004 13.9337 49.887 14.9292 49.887 14.9292L50.1048 14.2759C50.1048 14.2759 49.8559 13.5448 49.1093 13.5448C48.0049 13.5448 47.5383 14.307 47.5383 14.8981C47.5383 15.3025 47.5849 15.7069 47.8494 16.018H45.5473C45.5784 15.878 45.5939 15.7225 45.5939 15.5825C45.5939 14.6648 45.0029 13.9337 44.2718 13.9337C43.5407 13.9337 42.9497 14.6803 42.9497 15.5825C42.9497 15.738 42.9652 15.878 42.9963 16.018H40.632V12.1294C40.632 12.1294 39.9787 12.3316 39.7143 12.456C39.901 12.6271 39.901 12.7827 39.901 13.2648C39.901 13.4982 39.901 14.867 39.901 15.598C39.901 16.3758 39.4188 16.5158 39.4188 16.5158H40.1032H40.3054H43.1674C43.4007 16.9513 43.8052 17.2313 44.2562 17.2313C44.7073 17.2313 45.1117 16.9513 45.3451 16.5158H49.9803C50.447 16.5158 50.3848 15.8314 50.3848 15.8314ZM44.2874 16.8424C43.8985 16.8424 43.5718 16.2824 43.5718 15.598C43.5718 14.9136 43.8829 14.3537 44.2874 14.3537C44.6762 14.3537 45.0029 14.9136 45.0029 15.598C44.9873 16.2824 44.6762 16.8424 44.2874 16.8424Z",
      fill: "url(#paint21_linear)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M36.9145 13.887C37.1789 13.887 37.3811 13.6537 37.3811 13.3582C37.3811 13.0626 37.1634 12.8293 36.9145 12.8293C36.6656 12.8293 36.4478 13.0626 36.4478 13.3582C36.4478 13.6537 36.6501 13.887 36.9145 13.887Z",
      fill: "url(#paint22_linear)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M37.7233 13.9337C37.7544 13.9337 37.8167 13.9959 37.8478 14.027C37.8789 14.0581 37.91 14.1048 37.9411 14.1359C38.0033 14.2292 38.0189 14.3537 38.0344 14.4626C38.0811 14.9914 38.0811 15.6914 37.9255 16.2047C37.8011 16.5935 37.5367 16.9357 37.1167 17.0291C37.0078 17.0602 36.8989 17.0602 36.7745 17.0602C36.2923 17.0291 35.919 16.7646 35.7323 16.3291C35.499 15.7847 35.5612 15.0536 35.6079 14.4781C35.6235 14.2603 35.7168 14.0581 35.919 13.9493H34.488C34.5191 13.9493 34.5813 14.0115 34.6124 14.0426C34.6435 14.0737 34.6746 14.1204 34.7057 14.167C34.768 14.2759 34.7835 14.4003 34.7991 14.5092C34.8146 14.7114 34.7835 15.0692 34.7835 15.2714C34.7835 15.6603 34.8146 16.0491 34.9702 16.3913C35.1102 16.7335 35.359 17.0135 35.6701 17.2002C36.0279 17.4179 36.4634 17.4802 36.8834 17.4802C37.35 17.4802 37.8322 17.3713 38.19 17.0757C38.6877 16.6558 38.8744 15.9402 38.8588 15.3181C38.8588 15.1159 38.8433 14.7736 38.8433 14.5714C38.8433 14.447 38.8588 14.3226 38.921 14.2137C38.9521 14.1515 38.9833 14.1048 39.0144 14.0581C39.0455 14.027 39.1232 13.9493 39.1544 13.9493C39.1544 13.9337 37.7233 13.9337 37.7233 13.9337Z",
      fill: "url(#paint23_linear)"
    }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
      id: "paint0_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(32.5561 18.0747) scale(7.37459)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "paint1_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(32.5561 18.0747) scale(7.3746)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "paint2_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(32.5561 18.0747) scale(7.37459)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "paint3_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(46.26 16.6988) scale(7.24627)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "paint4_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(46.26 16.6988) scale(7.24627)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "paint5_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(46.26 16.6988) scale(7.24627)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "paint6_linear",
      x1: 10.6236,
      y1: 10.3602,
      x2: 11.8307,
      y2: 14.1108,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "paint7_linear",
      x1: 15.4794,
      y1: 12.9563,
      x2: 14.931,
      y2: 16.0185,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "paint8_linear",
      x1: 22.1653,
      y1: 11.8282,
      x2: 19.5016,
      y2: 14.4582,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "paint9_linear",
      x1: 8.3632,
      y1: 14.958,
      x2: 10.1,
      y2: 16.7862,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "paint10_linear",
      x1: 8.25362,
      y1: 24.0176,
      x2: 9.12202,
      y2: 23.4234,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "paint11_linear",
      x1: 12.6704,
      y1: 27.5971,
      x2: 13.317,
      y2: 25.2691,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "paint12_linear",
      x1: 19.1948,
      y1: 29.7009,
      x2: 16.9095,
      y2: 25.4047,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "paint13_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(15.3833 13.196) scale(0.856452)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "paint14_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(21.5655 11.86) scale(0.856452)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "paint15_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(10.5165 10.6371) scale(0.856452)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "paint16_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(8.25195 15.0303) scale(0.856452)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "paint17_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(5.80622 19.6727) scale(0.856452)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "paint18_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(7.25557 24.485) scale(0.856452)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "paint19_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(12.8954 27.4607) scale(0.856452)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "paint20_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(18.8965 29.363) scale(0.856452)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "paint21_linear",
      x1: 37.38,
      y1: 13.7401,
      x2: 42.6281,
      y2: 14.7241,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "paint22_linear",
      x1: 38.3323,
      y1: 12.2803,
      x2: 35.6593,
      y2: 14.3081,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "paint23_linear",
      x1: 39.1541,
      y1: 13.3635,
      x2: 36.4811,
      y2: 15.3914,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })))));
  };

  var _default = SvgOmannet;
  _exports["default"] = _default;
});